var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tests),function(test){return _c('vessel-trial-test-details',{key:test.vesselTrialTestId,staticClass:"mb-2",attrs:{"vessel-trial-test":test}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }